module.exports = __webpack_public_path__ + "static/media/fly0095.e79682c1.webp";